const EMAIL_REGEX =
  /^[_A-Z0-9+-]+(\.[_A-Z0-9+-]+)*@[A-Z0-9-]+(\.[A-Z0-9-]+)*(\.[A-Z]{2,4})$/i;

export const isValidEmail = (email: string) => {
  return EMAIL_REGEX.test(email);
};
